import React from 'react';

export default function InfringementNotice() {
  return (
    <div className="max-w-screen-md mx-auto mt-20 mb-14 font-brand text-gray-700">
      <div className="my-4">
        <h1 className="text-4xl">
          NOTICE AND PROCEDURE FOR MAKING CLAIMS OF COPYRIGHT INFRINGEMENT{' '}
        </h1>
        <h4 className="text-xl">
          NOTE: THE FOLLOWING INFORMATION IS PROVIDED EXCLUSIVELY FOR NOTIFYING
          THE SERVICE PROVIDERS REFERENCED BELOW THAT YOUR COPYRIGHTED MATERIAL
          MAY HAVE BEEN INFRINGED. ALL OTHER INQUIRIES WILL NOT RECEIVE A
          RESPONSE THROUGH THIS PROCESS.{' '}
        </h4>
      </div>
      <div className="prose text-gray-800">
        <p>
          Pursuant to Title 17, U.S. Code, Section 512(c)(2), written
          notification must be submitted to the following Designated Agent:
        </p>
        <p>
          Service Provider(s): Tokio Marine HCC 13403 Northwest Freeway Houston,
          TX 77040
        </p>
        <p>
          Name of Agent Designated to Receive<br></br>Notification of Claimed
          Infringement: Alexander Ludlow
        </p>
        <p>
          Full Address of Designated Agent to<br></br>Which Notification Should
          be Sent: 13403 Northwest Freeway, Houston, TX 77040
        </p>
        <p>Telephone Number of Designated Agent: (713) 462-1000</p>
        <p>Facsimile Number of Designated Agent: (713) 744-9648</p>
        <p>Email Address of Designated Agent: copyright@tmhcc.com </p>
        <p>To be effective, the Notification must include the following:</p>
        <ol>
          <li>
            A physical or electronic signature of a person authorized to act on
            behalf of the owner of an exclusive right that is allegedly
            infringed
          </li>
          <li>
            Identification of the copyrighted work claimed to have been
            infringed, or if multiple copyrighted works at a single online site
            are covered by a single notification, a representative list of such
            works at that site;
          </li>
          <li>
            Identification of the material that is claimed to be infringing or
            to be the subject of infringing activity and that is to be removed
            or access to which is to be disabled, and information reasonably
            sufficient to permit the service provider to locate the material;
          </li>
          <li>
            Information reasonably sufficient to permit the service provider to
            contact the Complaining Party, such as an address, telephone number,
            and if available, an electronic mail address at which the
            complaining party may be contacted;
          </li>
          <li>
            A statement that the Complaining Party has a good faith belief that
            use of the material in the manner complained of is not authorized by
            the copyright owner, its agent, or the law
          </li>
          <li>
            A statement that the information in the notification is accurate,
            and under penalty of perjury, that the Complaining Party is
            authorized to act on behalf of the owner of an exclusive right that
            is allegedly infringed.
          </li>
        </ol>
      </div>
    </div>
  );
}
